<template>
    <div>
        <div class="page-wrapper">
            <div class="page-content-wrapper">
                <div class="col-12 shadow-btm row">
                    <div class="col-lg-6 col-sm-6 my-auto">
                        <h4 class="mb-0 lg-bld">View Email</h4>
                    </div>
                </div>

                <div class="page-content">
                    <div class="card border mb-0 radius-15">
                        <div class="card-body p-0">

                            <!-- Tabs -->
                            <ul class="nav nav-tabs">
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ active: activeTab === 'list' }"
                                       @click="activeTab = 'list'">Users</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{ active: activeTab === 'preview' }"
                                       @click="activeTab = 'preview'">Preview</a>
                                </li>
                            </ul>

                            <!-- Email List Tab -->
                            <div v-show="activeTab === 'list'" class="p-3">
                                <div class="row mb-3">
                                    <div class="col-lg-6 col-sm-6 form-group row">
                                        <div class="has-search ml-3">
                                            <i class="fa fa-search" style="position: absolute; margin: 10px"
                                               aria-hidden="true"></i>
                                            <input type="text" class="form-control"
                                                   placeholder="Search by email"
                                                   v-model="searchObj.keyword"
                                                   @keyup.enter="getList(0)" />
                                        </div>
                                        <a class="search-btn btn-style cursor-pointer ml-3" @click="getList(0)">Search</a>
                                        <a class="search-btn btn-style cursor-pointer" @click="resetFilter">Reset</a>
                                    </div>
                                </div>

                                <div class="card border mb-0 radius-15">
                                    <div class="card-body p-0 pb-4">
                                        <div class="table-responsive">
                                            <div class="dataTables_wrapper dt-bootstrap4">
                                                <table class="table table-striped table-bordered dataTable table-font" style="width: 100%" role="grid">
                                                    <thead>
                                                        <tr role="row">
                                                            <th >Sr No</th>                                                    
                                                            <th class="sorting" id="email-col" v-on:click="sorting('email', 'email-col')">Email</th>
                                                            <th class="sorting" id="status-col" v-on:click="sorting('is_sent', 'status-col')">Is Sent</th>
                                                            <th class="sorting" id="sentat-col" v-on:click="sorting('sent_at', 'sentat-col')">Sent At</th>
                                                            <th id="failed-col">Failed Reason</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-show="!loader">
                                                        <tr v-for="(data, index) in list" :key="index">
                                                            <td>
                                                                {{
                                                                    ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage +
                                                                    index + 1
                                                                }}
                                                            </td>
                                                            <td>{{ data.email }}</td>
                                                            <td>
                                                                <a v-show="data.is_sent == 1" class="fill-btn btn-style">SENT</a>
                                                                <a v-show="data.is_sent == 0" class="reject-btn btn-style">NOT SENT</a>
                                                            </td>
                                                            <td>{{ data.sent_at || '-' }}</td>
                                                            <td>{{ data.failed_reason || '-' }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="row mx-0 mb-4">
                                            <div class="col-lg-12 mt-5 text-center">
                                                <div class="page-bottom-pagination text-right">
                                                    <Pagination @page-change="pageChange"
                                                                @items-per-page-change="itemsPerPageChange"
                                                                ref="listPagination" />
                                                </div>
                                            </div>
                                        </div>

                                        <ErrorComponent @retry="getList(0)" ref="errorComponent" />
                                    </div>
                                </div>
                            </div>

                            <!-- Preview Tab -->
                            <div v-show="activeTab === 'preview'" class="p-3">
                                <h5>{{ emailDetails.subject }}</h5>
                                <!-- <div v-html="emailDetails.body"
                                     style="background-color: #f9f9f9; padding: 10px; min-height: 200px;">
                                </div> -->
                                <!-- Preview Tab -->
                                <div v-show="activeTab === 'preview'" style="min-height: 200px;">
                                <iframe
                                    v-if="!isPreviewLoading"
                                    :srcdoc="emailDetails.body"
                                    style="width: 100%; height: 80vh; border: none; overflow: auto;"
                                    sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-scripts allow-top-navigation-by-user-activation"
                                ></iframe>
                                <div v-else style="text-align:center; padding:40px;">
                                    <img src="/img/loader.gif" alt="Loading..." style="height:48px;" />
                                </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";

export default {
    name: "ViewEmail",
    components: {
        ErrorComponent,
        Pagination,
    },
    data() {
        return {
            id: this.$route.params.id,
            loader: true,
            activeTab: "list",
            searchObj: {
                keyword: "",
            },
            offset: -1,
            list: [],
            emailDetails: {
                subject: "",
                body: "",
            },
            sortBy: "",
            orderBy: "ASC",
        };
    },
    mounted() {
        this.getList(0);
        this.getEmailDetails();
    },
    methods: {
        pageChange(offset) {
            this.getList(offset - 1);
        },
        itemsPerPageChange() {
            this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
            this.getList(0);
        },
        getList(page, orderBy, sortBy) {
            this.$refs.errorComponent.updateListLoader(true);
            this.list = [];
            this.searchObj.offset = page;
            if (orderBy) this.searchObj.order_by = orderBy;
            if (sortBy) this.searchObj.sort_by = sortBy;
            if (this.offset != page) {
                this.searchObj.offset = page;
            } else {
                this.searchObj.offset = page;
            }
            this.$api
                .getAPI({
                    _action: `/email_sends/list/${this.id}`,
                    _body: this.searchObj,
                })
                .then((res) => {
                    this.loader = false;
                    this.list = res.list || [];
                    this.offset = res.next_offset;

                    if (page == 0 && this.$refs.listPagination) {
                        this.$refs.listPagination.setTotalCount(res.count || 0);
                    }

                    if (this.$refs.errorComponent) {
                        this.$refs.errorComponent.setData(res, "No email records available");
                        this.$refs.errorComponent.updateListLoader(false);
                    }
                })
                .catch(() => {
                    this.loader = false;
                    if (this.$refs.errorComponent) {
                        this.$refs.errorComponent.setData(0, undefined, "");
                        this.$refs.errorComponent.updateListLoader(false);
                    }
                });
        },
        getEmailDetails() {
            this.$api
                .getAPI({
                    _action: `/email_logs/details/${this.id}`,
                })
                .then((res) => {
                    this.emailDetails = res;
                })
                .catch(() => {
                    this.emailDetails = {};
                });
        },
        sorting(sortBy, id) {
            var obj = this.$helperService.sorting(sortBy, id);
            this.getList(0, obj.order_by, obj.sort_by);
        },
        resetFilter() {
            this.searchObj.keyword = "";
            this.searchObj.order_by = "";
            this.searchObj.sort_by = "";
            this.emailDetails = {
                subject: "",
                body: "",
            };
            this.getList(0);
            this.getEmailDetails();
        },
    },
};
</script>
